// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file catalogos_satelite.proto (package sextante.catalogos.satelite.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catalogos_satelite.proto.
 */
export const file_catalogos_satelite: GenFile = /*@__PURE__*/
  fileDesc("ChhjYXRhbG9nb3Nfc2F0ZWxpdGUucHJvdG8SHnNleHRhbnRlLmNhdGFsb2dvcy5zYXRlbGl0ZS52MSJ+CgpJbmRpY2VJdGVtEgoKAmlkGAEgASgJEhEKCWVsaW1pbmFkbxgCIAEoCBIOCgZub21icmUYBCABKAkSEwoLZGVzY3JpcGNpb24YBSABKAkSFQoNcmFuZ29fY29sb3JlcxgGIAMoCRIVCg1sYWJlbF9jb2xvcmVzGAcgASgJIjMKEkxpc3RJbmRpY2VzUmVxdWVzdBIdChV1bHRpbWFfc2luY3Jvbml6YWNpb24YASABKAMicgoTTGlzdEluZGljZXNSZXNwb25zZRI5CgVpdGVtcxgBIAMoCzIqLnNleHRhbnRlLmNhdGFsb2dvcy5zYXRlbGl0ZS52MS5JbmRpY2VJdGVtEiAKGHRpbWVzdGFtcF9zaW5jcm9uaXphY2lvbhgCIAEoAzKSAQoYQ2F0YWxvZ29zU2F0ZWxpdGVTZXJ2aWNlEnYKC0xpc3RJbmRpY2VzEjIuc2V4dGFudGUuY2F0YWxvZ29zLnNhdGVsaXRlLnYxLkxpc3RJbmRpY2VzUmVxdWVzdBozLnNleHRhbnRlLmNhdGFsb2dvcy5zYXRlbGl0ZS52MS5MaXN0SW5kaWNlc1Jlc3BvbnNlQguqAghBcGkuR3JwY2IGcHJvdG8z");

/**
 * Indice satelital, como NDVI, con la escala de colores para pintarlo.
 *
 * @generated from message sextante.catalogos.satelite.v1.IndiceItem
 */
export type IndiceItem = Message<"sextante.catalogos.satelite.v1.IndiceItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string nombre = 4;
   */
  nombre: string;

  /**
   * @generated from field: string descripcion = 5;
   */
  descripcion: string;

  /**
   * Colores de la escala de la leyenda, en orden. El ultimo se usa para la linea de promedio del grafico.
   *
   * @generated from field: repeated string rango_colores = 6;
   */
  rangoColores: string[];

  /**
   * Texto de la leyenda de la escala de colores.
   *
   * @generated from field: string label_colores = 7;
   */
  labelColores: string;
};

/**
 * Describes the message sextante.catalogos.satelite.v1.IndiceItem.
 * Use `create(IndiceItemSchema)` to create a new message.
 */
export const IndiceItemSchema: GenMessage<IndiceItem> = /*@__PURE__*/
  messageDesc(file_catalogos_satelite, 0);

/**
 * Pedido del catalogo de indices.
 *
 * @generated from message sextante.catalogos.satelite.v1.ListIndicesRequest
 */
export type ListIndicesRequest = Message<"sextante.catalogos.satelite.v1.ListIndicesRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.satelite.v1.ListIndicesRequest.
 * Use `create(ListIndicesRequestSchema)` to create a new message.
 */
export const ListIndicesRequestSchema: GenMessage<ListIndicesRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_satelite, 1);

/**
 * Indices que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.satelite.v1.ListIndicesResponse
 */
export type ListIndicesResponse = Message<"sextante.catalogos.satelite.v1.ListIndicesResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.satelite.v1.IndiceItem items = 1;
   */
  items: IndiceItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.satelite.v1.ListIndicesResponse.
 * Use `create(ListIndicesResponseSchema)` to create a new message.
 */
export const ListIndicesResponseSchema: GenMessage<ListIndicesResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_satelite, 2);

/**
 * Migracion a gRPC-Web del catalogo de indices satelitales (ver CLAUDE.md, seccion migracion a
 * gRPC-Web). Mismo criterio de delta que catalogos_aplicaciones.proto (incluido no exponer
 * "ultima_actualizacion" -ver ese archivo-).
 *
 * @generated from service sextante.catalogos.satelite.v1.CatalogosSateliteService
 */
export const CatalogosSateliteService: GenService<{
  /**
   * Catalogo de indices satelitales, por delta.
   *
   * @generated from rpc sextante.catalogos.satelite.v1.CatalogosSateliteService.ListIndices
   */
  listIndices: {
    methodKind: "unary";
    input: typeof ListIndicesRequestSchema;
    output: typeof ListIndicesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catalogos_satelite, 0);

